import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../..";
import { IfilterObj } from "../types";
import { encode as base64Encode } from "base-64";
import { initialGeoRegion } from "../../../components/helpers";
import { LOCAL_STORAGE } from "../../../globals/globals";

export const geoRegionSelector = createSelector(
    [(state: AppState) => state.thresholdCrossingDeviceFilter.geoRegion],
    (geoRegion) => geoRegion || initialGeoRegion
);

export const addDeviceGeoRegionSelector = createSelector(
    [(state: AppState) => state.thresholdCrossingDeviceFilter.addDeviceGeoRegion],
    (geoRegion) => geoRegion || initialGeoRegion
);

export const profileKeySelector = (state: AppState) => state.thresholdCrossingDeviceFilter.profileKey;
export const siteGroupSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.siteGroup;
export const addDeviceSiteGroupSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.addDeviceSiteGroup;
export const isThresholdCrossingDeviceAssociationProgressSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.isThresholdCrossingDeviceAssociationProgress || false;
export const isAssociatedDevicesRemovedSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.isAssociatedDevicesRemoved || false;
export const ruleNameSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.ruleName;
export const networkTypeSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.networkType;
export const thresholdStateSelector = (state: AppState) => state.thresholdCrossingDeviceFilter.thresholdState;

export const urlParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    profileKeySelector,
    isThresholdCrossingDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, groupKey, isThresholdCrossingDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        const paramsString: IfilterObj = { type: "AND", operator: "", fieldName: "", value: "", predicates: [] };

        if (isThresholdCrossingDeviceAssociationProgress) {
            if (geoAddDeviceRegionName && geoAddDeviceRegionName.name) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoAddDeviceRegionName.name, predicates: [{}] });
            }

            if (addDeviceSiteGroup) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: addDeviceSiteGroup, predicates: [{}] });
            }
        }
        else {
            if (geoRegionName && geoRegionName.name) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "geoRegionName", value: geoRegionName.name, predicates: [{}] });
            }

            if (siteGroup) {
                paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "siteGroupName", value: siteGroup, predicates: [{}] });
            }
        }

        if (groupKey && groupKey.value !== "NONE") {
            paramsString.predicates.push({ type: "", operator: "EQUAL", fieldName: "groupKey", value: isThresholdCrossingDeviceAssociationProgress ? "" : groupKey.value, predicates: [{}] });
        }
        console.log('paramsString', paramsString);
        const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
        if (paramsString?.predicates.length > 0) {
            base64EncodedStr && params.append("filters", base64EncodedStr);
        }

        return params;
    }
);


export const urlRemoveParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    profileKeySelector,
    isThresholdCrossingDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, groupKey, isThresholdCrossingDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        params.set("region", geoRegionName?.name || "");
        params.set("group", siteGroup);
        return params;
    }
);

export const urlAddParameterSelector = createSelector(
    siteGroupSelector,
    addDeviceSiteGroupSelector,
    geoRegionSelector,
    addDeviceGeoRegionSelector,
    profileKeySelector,
    isThresholdCrossingDeviceAssociationProgressSelector,

    (siteGroup, addDeviceSiteGroup, geoRegionName, geoAddDeviceRegionName, groupKey, isThresholdCrossingDeviceAssociationProgress) => {
        const params = new URLSearchParams();
        params.set("region", geoAddDeviceRegionName?.name || "");
        params.set("group", addDeviceSiteGroup);
        return params;
    }
);

// Alerts only depend on ruleName + networkType; keep selector simple
export const urlAlertParameterSelector = createSelector(
    ruleNameSelector,
    networkTypeSelector,
    thresholdStateSelector,
    (ruleName, networkType, thresholdState) => {
        const currentRegionString = localStorage.getItem(LOCAL_STORAGE.CURRENTREGION);
        const currentRegion = currentRegionString ? JSON.parse(currentRegionString) : null;
        const regionName = currentRegion?.name || "";
        
        const params = new URLSearchParams();
        params.set("region", regionName ?? "");
        params.set("rulename", ruleName ?? "");
        params.set("kpitype", networkType ?? "");
        if (thresholdState === "ACTIVE") {
            params.set("active", "true");
        } else if (thresholdState === "CLEARED") {
            params.set("active", "false");
        }
        return params;
    }
);